module.exports = __webpack_public_path__ + "static/media/bitcoin-wallet.d6496a78.jpg";